module.exports = __webpack_public_path__ + "img/ring_g_skip_null_0.3095d442.png";